import { IAccount } from "src/domain/entities"
import { accountListApi } from "../../api/account/accountListApi"

type PayloadShape = Parameters<typeof accountListApi>[0]

export async function accountListService(payload: PayloadShape, token?: null | string) {
	const account = await accountListApi(payload, token)
	return account as NonNullable<IAccount[]>
}
